var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Calendar',{attrs:{"dateFormat":"dd.mm.yy","showButtonBar":true,"disabled":_vm.disabled,"showIcon":true},model:{value:(_vm.localDate),callback:function ($$v) {_vm.localDate=$$v},expression:"localDate"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }